// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"1c0d58ed","754":"edb19014","962":"21c35933"}[chunkId] + ".chunk.css";
};